import { render, staticRenderFns } from "./evaluation-score.vue?vue&type=template&id=3fd74bf2"
import script from "./evaluation-score.vue?vue&type=script&lang=js"
export * from "./evaluation-score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports